'use client';

import React, { createContext, useContext } from 'react';
import type { Entitlements } from './types';

const EntitlementsContext = createContext<Entitlements | null>(null);

export const EntitlementsProvider = ({
  value,
  children,
}: {
  value: Entitlements | null;
  children: React.ReactNode;
}) => {
  return (
    <EntitlementsContext.Provider value={value}>
      {children}
    </EntitlementsContext.Provider>
  );
};

export const EntitlementsTestProvider = ({
  value,
  children,
}: {
  value: Partial<Entitlements>;
  children: React.ReactNode;
}) => {
  return (
    <EntitlementsContext.Provider value={value as Entitlements}>
      {children}
    </EntitlementsContext.Provider>
  );
};

export function useEntitlementsContext() {
  const context = useContext(EntitlementsContext);

  return context;
}
